import {
  createInitialProgression,
  grantExp,
  loadCharacterProgression,
  saveCharacterProgression,
  type CharacterProgression,
} from "@/game/model/character-progression";
import { HomeEvents } from "@/home/home-events";

/** Quests, item cards, and other non-combat EXP sources. */
export function grantExpForUser(userId: string, amount: number): CharacterProgression {
  const current = loadCharacterProgression(userId);
  const { progression, levelsGained } = grantExp(current, amount);
  saveCharacterProgression(userId, progression);
  window.dispatchEvent(
    new CustomEvent(HomeEvents.ProgressionChanged, {
      detail: { progression, levelsGained },
    }),
  );
  return progression;
}

/** GM: reset level, EXP, stat points, and allocated stats for a user (local save). */
export function resetProgressionForUser(userId: string): CharacterProgression {
  const progression = createInitialProgression();
  saveCharacterProgression(userId, progression);
  window.dispatchEvent(
    new CustomEvent(HomeEvents.ProgressionChanged, {
      detail: { progression, levelsGained: 0 },
    }),
  );
  return progression;
}
